import BlockArticle from '@bridebook/web/app-basic/components/blocks/block-article';
import {
  getArticlesList,
  getIsArticlesListLoaded,
} from '@bridebook/web/app-basic/lib/article/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import { Box, Col, Row } from '@bridebook/ui';
import componentStyles from './search-location-articles.style';

const SearchLocationArticles = () => {
  const { t } = useTranslation('search');
  const loaded = useSelector(getIsArticlesListLoaded);
  const list = useSelector(getArticlesList);
  const styles = componentStyles();

  return loaded && list.length > 0 ? (
    <Box style={styles.wrapper}>
      <Box as="h2" style={styles.heading}>
        {t('location.relatedArticles')}
      </Box>
      <Row style={styles.articleList}>
        {list.map((article) => (
          <Col lg={6} key={`searchlocationarticle_${article.slug}`} style={styles.articleWrap}>
            <BlockArticle article={article} size="medium" />
          </Col>
        ))}
      </Row>
    </Box>
  ) : null;
};

export default memo(SearchLocationArticles);
